interface Props {
  errorMessage: string
}

const ErrorDisplay: React.FC<Props> = ({ errorMessage }) => {
  if (errorMessage) {
    return (
      <div className="mt-[20px] text-lg text-red-500">
        <h1>{errorMessage}</h1>
      </div>
    )
  }

  return ''
}

export default ErrorDisplay
